import { jsx as e } from "react/jsx-runtime";
import { useMemo as a } from "react";
import { n as p } from "../../index-DDwX5WiL.js";
import "../../theme/spacing.js";
import "../../utils/normalizeForCollation/index.js";
import "../../hooks/useInputSystem/system/constants.js";
import "../../hooks/useInputSystem/key/constants.js";
import "../../hooks/useInputSystem/provider/context.js";
import { useRelativeTimeFormatter as T } from "../../hooks/useRelativeTimeFormatter/index.js";
import { ErrorBoundary as d } from "../ErrorBoundary/index.js";
import { useTimeAgo as f } from "./useTimeAgo.js";
import '../../assets/index60.css';const l = "_dateTime_1294y_1", g = {
  dateTime: l
};
function h({ dateTime: t, continuous: r = !0 }) {
  const [c, s] = a(() => {
    const n = p(t);
    return [n, n.toString()];
  }, [t]), [o, m] = f(c, r), i = T({ numeric: "auto", style: "narrow" }), u = a(() => i.format(o, m), [i, o, m]);
  return /* @__PURE__ */ e("time", { dateTime: s, className: g.dateTime, "data-component": "TimeAgo", children: u });
}
function w({ dateTime: t, continuous: r = !0 }) {
  return /* @__PURE__ */ e(d, { fallback: /* @__PURE__ */ e("span", { children: "Invalid date" }), children: /* @__PURE__ */ e(h, { dateTime: t, continuous: r }) }, String(t));
}
export {
  w as TimeAgo
};
